import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ParkIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ParkIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M21.9876 19.4375H20.8671V18.5105H21.4835C21.7385 18.5105 21.9461 18.3029 21.9461 18.048V16.1192C21.9461 15.8643 21.7385 15.6567 21.4835 15.6567H20.3841V14.8713H21.0958C21.3508 14.8713 21.5584 14.6636 21.5584 14.4087V12.48C21.5584 12.225 21.3508 12.0174 21.0958 12.0174H20.3841V11.7226C20.3841 11.4676 20.1764 11.26 19.9215 11.26C19.6665 11.26 19.4589 11.4676 19.4589 11.7226V12.0174H14.2728V11.7226C14.2728 11.4676 14.0652 11.26 13.8102 11.26C13.5552 11.26 13.3476 11.4676 13.3476 11.7226V12.0174H13.0505C13.0406 11.2296 12.761 10.4694 12.2598 9.8676C12.4148 9.5091 12.4961 9.11494 12.4961 8.72429C12.4961 7.13769 11.2048 5.84643 9.61824 5.84643C9.06794 5.84643 8.53985 5.99906 8.08194 6.28855C7.9948 4.8154 6.76027 3.63818 5.26899 3.63818C3.71455 3.63818 2.4502 4.90254 2.4502 6.45639V12.3957C2.4502 13.7683 3.45841 14.952 4.80641 15.1759V19.4375H2.91279C2.65781 19.4375 2.4502 19.6451 2.4502 19.9001C2.4502 20.155 2.65781 20.3626 2.91279 20.3626H21.9876C22.2426 20.3626 22.4502 20.155 22.4502 19.9001C22.4502 19.6451 22.2426 19.4375 21.9876 19.4375ZM19.9419 18.5105V19.4375H13.7897V18.5105H19.9419ZM21.0209 16.5818V17.5854H12.7107V16.5818H21.0209ZM10.0808 15.4602C10.8925 15.3508 11.6265 14.9596 12.1733 14.3484V14.4087C12.1733 14.6636 12.3809 14.8713 12.6359 14.8713H13.3476V15.6567H12.2482C11.9932 15.6567 11.7856 15.8643 11.7856 16.1193V18.048C11.7856 18.3029 11.9932 18.5106 12.2482 18.5106H12.8645V19.4375H10.0808L10.0808 15.4602ZM9.61824 10.6068C9.36326 10.6068 9.15565 10.8144 9.15565 11.0694V14.5239C8.61411 14.4239 8.11937 14.1449 7.74976 13.7309C7.97081 13.3221 8.0872 12.8618 8.0872 12.3958V7.51257C8.46089 7.04121 9.01763 6.77161 9.61824 6.77161C10.6949 6.77161 11.5709 7.64766 11.5709 8.72429C11.5709 9.07283 11.4791 9.41378 11.3048 9.71028C11.1972 9.89333 11.2276 10.1249 11.3785 10.274C11.8604 10.7489 12.1253 11.3828 12.1253 12.0595C12.1253 13.2595 11.2522 14.3034 10.0808 14.5239V13.1221L10.9621 12.2413C11.1423 12.0606 11.1423 11.7676 10.9621 11.5869C10.7808 11.4068 10.4884 11.4068 10.3071 11.5869L10.0808 11.8138V11.0694C10.0808 10.8144 9.87322 10.6068 9.61824 10.6068ZM13.0985 13.9461V12.9426H20.6332V13.9461H13.0985ZM19.4589 14.8713V15.6567H14.2728V14.8713H19.4589ZM5.73158 15.1759C6.27312 15.0865 6.76962 14.8438 7.17548 14.4701C7.70707 15.011 8.40534 15.3607 9.15565 15.4607V19.4375H5.73158V15.1759ZM5.26899 8.96349C5.01401 8.96349 4.8064 9.1711 4.8064 9.42608V14.2321C3.97187 14.0221 3.37537 13.2636 3.37537 12.3958V6.4564C3.37537 5.41252 4.2251 4.56336 5.26899 4.56336C6.31287 4.56336 7.16203 5.41251 7.16203 6.4564V12.3958C7.16203 13.2636 6.56552 14.0215 5.73158 14.2321V9.42608C5.73158 9.1711 5.52397 8.96349 5.26899 8.96349Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ParkIcon;
